// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AF zQ","wrapperNeon":"AG z2","ribbon":"AH zZ","title":"AI zS","seasons":"AJ zX","genres":"AK zY","buttonWrapper":"AL zU","button":"AM zV","buttonNeon":"AN z3"};